import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
})
export class AssistanceComponent implements OnInit {
  @Input() item: any;

  constructor(private readonly modalService: NgbModal) {}

  ngOnInit(): void {
    console.log(this.item);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
